// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"6ea45e71","977":"5236ce8a"}[chunkId] + ".chunk.js";
};